// The controllers whose rows carry an `isArchived` flag.
//
// This drives three things:
//   * the Archive row action (GridPageAbstract.allowedArchive),
//   * hiding archived rows by default, with the toolbar's "show archived" toggle
//     to bring them back (GridPageAbstract.applyDefaultArchiveFilter /
//     toggleArchived),
//   * excluding archived rows from the Select dropdowns that are populated from
//     another controller (GridPageAbstract.updateContextControllersData).
//
// Kept in step with the backend by hand: these are exactly the entities with an
// `is_archived` column — Agent, GatewayApi, GatewayRule, Gateway, GatewaySettings,
// Merchant, MerchantTerminal, ScraperScenario, TgBot, TgSession, Wallet, WalletRule.
// An archived gateway settings row drops out of the gateway form's four settings
// pickers, which is the point: a gateway may not link one
// (TRIGGER_GATEWAY_SETTINGS_ARCHIVED). An archived scraper scenario likewise drops
// out of the settings form's scenario picker: one cannot be archived while settings
// use it (TRIGGER_SCRAPER_SCENARIO_IN_USE), so nothing new should start to. TgUnknownChat is
// deliberately absent: it has no such column, and its rows are pruned by the
// reconciler rather than archived by hand. TgSessionChat and TgSessionMessage are
// absent too: core writes both from what tg-client reports, and neither has the
// column. Adding a controller here that has no such
// column makes its list requests filter on a field the API does not know.
//
// Matching is by controller, not by the head config's `object` name: one
// controller is referenced under several object names (publicGateways appears as
// `gateway`, `payinGateway` and `payoutGateway`), so keying on `object` silently
// missed most of them.
//
// `publicMerchantTerminalGateways` used to be listed here. It has no is_archived
// column — it does not exist as an entity in cabinet-db at all — so it was dropped
// rather than left filtering on a field that does not exist. `publicGatewaySettings`
// was dropped with it, and is back since V28 made it a real entity with the column.
export const archiveSupportConfig = [
    { controller: 'publicAgents', entity: 'agent' },
    { controller: 'publicGatewayApis', entity: 'gatewayApi' },
    { controller: 'publicGatewayRules', entity: 'gatewayRule' },
    { controller: 'publicGateways', entity: 'gateway' },
    { controller: 'publicGatewaySettings', entity: 'gatewaySettings' },
    { controller: 'publicMerchants', entity: 'merchant' },
    { controller: 'publicMerchantTerminals', entity: 'merchantTerminal' },
    { controller: 'publicScraperScenarios', entity: 'scraperScenario' },
    { controller: 'publicTgBots', entity: 'tgBot' },
    { controller: 'publicTgSessions', entity: 'tgSession' },
    { controller: 'publicWallets', entity: 'wallet' },
    { controller: 'publicWalletRules', entity: 'walletRule' }
];

/** True when `controller` has an is_archived column. */
export const controllerSupportsArchive = (controller) =>
    archiveSupportConfig.some((cfg) => cfg.controller === controller);
